import React from 'react'
import {
  Skeleton as ChakraSkeleton,
  SkeletonProps as ChakraSkeletonProps,
} from '@chakra-ui/react'

interface SkeletonProps extends ChakraSkeletonProps {}

const Skeleton: React.FC<SkeletonProps> = ({ ...props }) => {
  return <ChakraSkeleton height="16px" {...props} />
}

export default Skeleton
